import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getOperationsReplenishment = (params) => {
    return axios.get(`${backendHost}/api/admin/ggr/operations/replenishment`, {params});
};

export {
    getOperationsReplenishment
}